import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const vehicleChargeOptions = [
  { label: 'Full night', value: 'night' },
  { label: 'Full day', value: 'day' },
  { label: 'Varies between daytime and nighttime', value: 'varies' },
]

export const vehicleCharge = {
  component: QuestionWrapper,
  componentProps: {
    type: 'radio',
    title: 'What time do you normally charge your vehicle?',
    label: 'Energy consumption',
    subtitle: 'Select an option.',
    options: vehicleChargeOptions,
    formValue: 'vehicleChargeTime',
    tooltip:
      "Since EV charging is energy-intensive, we'll factor that in to find you the best plan.",
    canSkip: true,
    tracking: {
      stepName: 'EV Charging Time',
      deepStepNumber: 5,
      quickStepNumber: 5,
      deepStepId: '5',
      quickStepId: '5',
      fieldName: 'ev_charging_time',
    },
  },
  name: 'vehicleChargeRadioGroup',
  schema: z.object({
    vehicleChargeTime: z.string().min(2, 'Please select one of the options above.'),
  }),
  visibleIf: {
    comparisonOperator: 'includes' as const,
    expectedAnswer: 'electricVehicle',
    formStepKey: 'householdIncludes',
  },
}
